<template>
    <div class="jzmx">
        <el-card>
            <main>
                <el-select v-model="status" placeholder="状态" clearable style="width:45%">
                    <el-option label="待核销" value="0"></el-option>
                    <el-option label="已核销" value="1"></el-option>
                </el-select>
                <el-select v-model="org" placeholder="公司" clearable style="width:45%;margin-left: 10%;">
                    <el-option label="义乌本部" value="义乌本部"></el-option>
                    <el-option label="华农家禽" value="华农家禽"></el-option>
                    <el-option label="生猪采购" value="生猪采购"></el-option>
                    <el-option label="肉制品" value="肉制品"></el-option>
                </el-select>
            </main>
            <br>

            <el-date-picker
                style="width:35%;"
                size="mini"
                v-model="time1"
                type="date"
                placeholder="起止日期">
            </el-date-picker>
            <span style="margin: 0 10px;">至</span>
            <el-date-picker
                style="width:35%;"
                size="mini"
                v-model="time2"
                type="date"
                placeholder="起止日期">
            </el-date-picker>

            <el-button type="primary" style="margin-left:10px" @click="search()" size="mini">搜索</el-button>
          
            <br/>
            <br/>
            
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">
                
                <el-table-column
                    width="90"
                    prop="kname"
                    label="车牌">
                </el-table-column>


                <el-table-column
                    width="150"
                    prop="time"
                    label="加注时间">
                </el-table-column>

                <el-table-column
                    prop="price"
                    label="加注金额">
                </el-table-column>

                <el-table-column
                    prop="weight"
                    label="加注体积">
                </el-table-column>

                <el-table-column
                    width="90"
                    prop="type"
                    label="加注模式">
                </el-table-column>

                <el-table-column
                    prop="number"
                    label="加注序号">
                </el-table-column>

                <el-table-column
                    prop="kahao"
                    width="50"
                    label="卡号">
                </el-table-column>

                <el-table-column
                    width="90"
                    prop="kaid"
                    label="卡ID">
                </el-table-column>

                <el-table-column
                    prop="q_price"
                    label="消费前">
                </el-table-column>

                <el-table-column
                    prop="h_price"
                    label="消费后">
                </el-table-column>

                <el-table-column
                    prop="org"
                    label="所属单位">
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待核销</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">核销成功</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="shenpiren"
                    label="核销人">
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0;"
                small
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

                
        </el-card>
    </div>
</template>

<script>
import { url,url2 } from '../router/api';

export default {
    data() {
        return {
            status:'',
            org:'',
            tableData:[],
            chepai:'',
            total: 1,
            per_page: 50,
            current_page: 1,
            time1:'',
            time2:''
        }; 
    },
  
    async mounted() {
        await this.getTime()
        await this.searchDb()
    },
    methods: {
        async getTime() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            this.time1 = Y + M + '01'
            this.time2 = Y + M + D
        },
        handleCurrentChange(val) {
            this.current_page = val;
            this.searchDb();
        },
        async searchDb() {
            var time1 = ''
            var time2 = ''
            if(this.time1&&this.time2) {
                time1 = this.time1 + ' 00:00'
                time2 = this.time2 + ' 23:59'
            }
            await this.axios.get(url + 'complaint/searchYhdb', {
                params:{
                    chepai:this.chepai,
                    time1:time1,
                    time2:time2,
                    status:this.status,
                    org:this.org,
                    page:this.current_page,
                    per_page:this.per_page,
                }
            }).then(res=> {
                this.tableData = res.data.data.data
                this.total = res.data.data.total
            }).catch(err=> {
                console.log(err);
            });
        },

        search() {
            this.current_page = 1
            this.searchDb()
        },
        
       
    },
};
</script>
<style lang="less" scoped>
.jzmx .main {
    display: flex;
}
</style>


